import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useClient } from './useClient';
import { DeleteChannelResponse } from '@hud/portal-dtos/channels.dtos';
import { CHANNELS_KEY } from './useChannels';

export default function useDeleteChannelMutation() {
  const { client } = useClient();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (channelId: string) => {
      const response = await client.delete<DeleteChannelResponse>(
        `/channels/${channelId}`,
      );
      return DeleteChannelResponse.parse(response.data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CHANNELS_KEY] });
    },
  });
}
